import { render, staticRenderFns } from "./colorsComponent.vue?vue&type=template&id=0ff8e2fa"
import script from "./colorsComponent.vue?vue&type=script&lang=js"
export * from "./colorsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports